import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../../../../services/AxiosInstance";
import MultiSelect from "../../../Forms/Element/MultiSelect";
import { useBranch } from "../../../../../context/BranchContext";

/**
 * Exibe os produtos.
 */
const ProductWithStockControlMultiSelect = (props) => {

    const { t } = useTranslation();
    const [options, setOptions] = useState([]);
    const { selectedBranch } = useBranch();

    useEffect(() => {
        let branchId = -1;
        if (selectedBranch !== null) {
            branchId = selectedBranch.id;
        }
        
        axiosInstance.get(`/main/products/with-track-stock/${branchId}`).then((response) => {
            let options = [];

            for (var i = 0; i < response.data.length; i++) {
                options.push(
                    {
                        value: response.data[i].id,
                        label: response.data[i].name
                    }
                );

                setOptions(options);
            }
        });
    }, [selectedBranch]);

    return (
        <MultiSelect
            options={options}
            placeholder={t("select")}
            {...props} />
    )
}

export default ProductWithStockControlMultiSelect;